export default __webpack_public_path__ + "static/banner-996e2c5ecf5cd911258463dede323c46.jpg";